<div class="limiter">
  <div class="container-login100">
    <div class="loading-shade" *ngIf="isLoading">
      <mat-spinner></mat-spinner>
    </div>
    <form
      autocomplete="off"
      [formGroup]="validateUserForm"
      class="validate-user-form"
    >
      <div class="text-center">
        <img
          class="login-logo"
          height="120px"
          src="assets/images/ez-logo.png"
          alt="Logo"
        />
      </div>
      <h4 class="text-center">Validate User</h4>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label class="text-danger"> Email </label>
            <input
              formControlName="userName"
              class="form-control"
              type="text"
            />
            <div
              *ngIf="
                validateUserForm.get('userName').touched &&
                validateUserForm.get('userName').errors
              "
            >
              <div
                class="text-danger"
                *ngIf="validateUserForm.get('userName').errors?.required"
              >
                Email Address is required.
              </div>
              <div
                class="text-danger"
                *ngIf="validateUserForm.get('userName').hasError('userName')"
              >
                Enter a valid email address.
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label class="text-danger"> Password </label>
            <div class="input-group">
              <input
                formControlName="password"
                class="form-control"
                type="text"
              />
              <div class="input-group-append">
                <span class="input-group-text cursor-pointer">
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-eye-slash': !fieldTextType,
                      'fa-eye': fieldTextType
                    }"
                    (click)="fieldTextType = !fieldTextType"
                  ></i>
                </span>
              </div>
              <div
                *ngIf="
                  validateUserForm.get('password').touched &&
                  validateUserForm.get('password').errors
                "
              >
                <div
                  class="text-danger"
                  *ngIf="validateUserForm.get('password').errors?.required"
                >
                  Password is required.
                </div>
                <div *ngIf="validateUserForm.get('password').errors?.minlength">
                  {{ "YOU_HAVE_TO_ENTER_AT_LEAST_6_DIGIT" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 col-sm-8 col-8">
          <button
            class="btn btn-success btn-sm m-right-10"
            (click)="checkUserValidate()"
            cdkFocusInitial
          >
            <i class="fas fa-save"></i> Validate
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
